import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicProjectRenameParamsRawI,
	LWApiPublicProjectRenameResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { PROJECT_DETAILS_QUERY_KEY } from './useDetails';
import { PROJECT_LIST_QUERY_KEY } from './useList';

const useProjectRename = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicProjectRenameResultRawI,
		ApiErrorI,
		LWApiPublicProjectRenameParamsRawI
	>({
		mutationFn: (params) => api.project.apiRaw.rename(params),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({
				queryKey: [PROJECT_DETAILS_QUERY_KEY, { id: variables.id }],
			});

			queryClient.invalidateQueries({ queryKey: [PROJECT_LIST_QUERY_KEY] });
		},
		onError: snackbarError,
	});
};

export default useProjectRename;
